/**
 * 全局图标前缀
 */
export const ICON_PREFIX = "vi-"

export const IMPORT_META_ENV: Partial<ImportMetaEnv> = {
  VITE_APP_TITLE: import.meta.env.VITE_APP_TITLE,
  VITE_VERSION_URL: import.meta.env.VITE_VERSION_URL,
  VITE_I18N_URL: import.meta.env.VITE_I18N_URL,
  VITE_I18N_APP: import.meta.env.VITE_I18N_APP,
  VITE_OMS_URL: import.meta.env.VITE_OMS_URL,
}

export enum LocaleEnum {
  ZH_CN = "zh-CN",
  EN_US = "en-US",
}

export * from "./props"
